// actions.js

import axios from 'axios';


export default {
    async fetchRulesList(ctx){
        const access_token = ctx.rootGetters.access_token;
        const config = {
            headers: {
                'Authorization': `${access_token}`
            }
        };
        try {
            const response = await axios.get(`${process.env.VUE_APP_APIGATEWAY}/api/v1/rules`, config);
            ctx.commit('updateRulesList', response.data) ;
        } catch (error) {
            return error;
        }
    },
    async fetchRulesListByDevice(ctx, {id}){
        const access_token = ctx.rootGetters.access_token;
        const config = {
            headers: {
                'Authorization': `${access_token}`
            }
        };
        try {
            const response = await axios.get(`${process.env.VUE_APP_APIGATEWAY}/api/v1/rules/by-device/${id}`, config);
            ctx.commit('updateSelectedDeviceRules', response.data) ;
        } catch (error) {
            return error;
        }
    },
    async fetchSaveRule(ctx, payload){
        try{
            const access_token = ctx.rootGetters.access_token;
            const response = await axios.post(
                `${process.env.VUE_APP_APIGATEWAY}/api/v1/rules`,
                {
                    name: payload.name,
                    priority: payload.priority,
                    device_id: payload.device_id,
                    user_roles: payload.user_roles,
                    duration: payload.duration,
                },
                {
                    headers: {
                        'Authorization': `${access_token}`
                    }
                }
            );
            return {
                status: response.status,
                data: response.data
            };
        } catch (error) {
            if (error.response) {
                // Сервер вернул ответ с ошибкой (код статуса не в диапазоне 2xx)
                return {
                    status: error.response.status,
                    message: error.response.data.message || 'Registration failed'
                };
            } else if (error.request) {
                // Запрос был сделан, но ответа не получено
                return {
                    status: 0,
                    message: 'No response received from server'
                };
            } else {
                // Что-то пошло не так при настройке запроса
                return {
                    status: -1,
                    message: error.message
                };
            }
        }
        
    },
    async fetchUpdateRule(ctx, payload){
        try{
            const access_token = ctx.rootGetters.access_token;
            const response = await axios.put(
                `${process.env.VUE_APP_APIGATEWAY}/api/v1/rules/${payload.id}`,
                {
                    name: payload.name,
                    priority: payload.priority,
                    device_id: payload.device_id,
                    user_roles: payload.user_roles,
                    duration: payload.duration,
                },
                {
                    headers: {
                        'Authorization': `${access_token}`
                    }
                }
            );
            return {
                status: response.status,
                data: response.data
            };
        } catch (error) {
            if (error.response) {
                // Сервер вернул ответ с ошибкой (код статуса не в диапазоне 2xx)
                return {
                    status: error.response.status,
                    message: error.response.data.message || 'Registration failed'
                };
            } else if (error.request) {
                // Запрос был сделан, но ответа не получено
                return {
                    status: 0,
                    message: 'No response received from server'
                };
            } else {
                // Что-то пошло не так при настройке запроса
                return {
                    status: -1,
                    message: error.message
                };
            }
        }

    },
    async fetchDeleteRule(ctx, {id}){
        const access_token = ctx.rootGetters.access_token;
        const config = {
            headers: {
                'Authorization': `${access_token}`
            }
        };
        try {
            const response = await axios.delete(`${process.env.VUE_APP_APIGATEWAY}/api/v1/rules/${id}`, config);
            return {
                status: response.status,
                data: response.data
            };
        } catch (error) {
            if (error.response) {
                // Сервер вернул ответ с ошибкой (код статуса не в диапазоне 2xx)
                return {
                    status: error.response.status,
                    message: error.response.data.message || 'Registration failed'
                };
            } else if (error.request) {
                // Запрос был сделан, но ответа не получено
                return {
                    status: 0,
                    message: 'No response received from server'
                };
            } else {
                // Что-то пошло не так при настройке запроса
                return {
                    status: -1,
                    message: error.message
                };
            }
        }
    }
};
